import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';
import { DocumentUploadService, DocumentDownloadService } from 'gw-portals-document-js';

export default class ServiceRequestService {
    static nagCalculationAmount(nagCode, deduction, isPorcent, taxID, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'nagCalculationCost', [nagCode, deduction, isPorcent, taxID], additionalHeaders);
    }

    // eslint-disable-next-line camelcase
    static getAllNagKeys_AX(nagCode, deduction, isPorcent, taxID, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'getAllNagKeys_AX', [nagCode, deduction, isPorcent, taxID], additionalHeaders);
    }

    static getConfigProviderByName_AX(name, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'getConfigProviderByName',
            [name], additionalHeaders);
    }

    static getServiceRequestsForVendor(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'getServiceRequestsForVendor', [], additionalHeaders);
    }

    static getServiceRequestDetails(serviceRequestNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'getServiceRequestDetails', [serviceRequestNumber], additionalHeaders);
    }

    static updateReferenceNumber(serviceRequestNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'updateReferenceNumber', [serviceRequestNumber], additionalHeaders);
    }

    // eslint-disable-next-line camelcase
    static getServiceRequestDetailsWithOutDocument_AX(serviceRequestNumber,
        additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'getServiceRequestDetailsWithOutDocument_AX', [serviceRequestNumber], additionalHeaders);
    }

    static getMessagesForSpecialist(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'getMessagesForSpecialist', [], additionalHeaders);
    }

    static acceptWork(acceptWorkDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'acceptWork', [acceptWorkDTO], additionalHeaders);
    }

    static declineWork(serviceRequestAction, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'declineWork', [serviceRequestAction], additionalHeaders);
    }

    static cancelServiceRequest(serviceRequestAction, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'cancelServiceRequest', [serviceRequestAction], additionalHeaders);
    }

    static completeWork(serviceRequestNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'completeWork', [serviceRequestNumber], additionalHeaders);
    }

    static reportBlocked(serviceRequestAction, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'reportBlocked', [serviceRequestAction], additionalHeaders);
    }

    static uploadDocument(file, documentMetadata, additionalHeaders = {}) {
        return DocumentUploadService.send(getProxiedServiceUrl('serviceRequestDocUpload'), file, documentMetadata, additionalHeaders);
    }

    static generateUploadToken(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequestDocs'), 'generateUploadToken', [], additionalHeaders);
    }

    static addOrReplaceQuote(publicID, quoteDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'addOrReplaceQuote', [publicID, quoteDTO], additionalHeaders);
    }

    static reportDelay(serviceRequestReportDelay, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'reportDelay', [serviceRequestReportDelay], additionalHeaders);
    }

    static addInvoice(serviceRequestNumber, invoice, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'addInvoice', [serviceRequestNumber, invoice], additionalHeaders);
    }

    static withdrawInvoice(withdrawInvoice, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'withdrawInvoice', [withdrawInvoice], additionalHeaders);
    }

    static resumeWork(serviceRequestNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'resumeWork', [serviceRequestNumber], additionalHeaders);
    }

    static createMessage(serviceRequestNumber, message, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'createMessage', [serviceRequestNumber, message], additionalHeaders);
    }

    static downloadDocumentLink(documentID, token) {
        return DocumentDownloadService.getDocumentLink(getProxiedServiceUrl('serviceRequestDownloadDocument'), documentID, token);
    }

    static updateMedicalPackage(serviceRequestAction, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'updateMedicalPackage_ax', [serviceRequestAction], additionalHeaders);
    }

    static updateTheftResolution(serviceRequestAction, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'updateTheftResolution_ax', [serviceRequestAction], additionalHeaders);
    }

    static getSystemParameterStringByNameAX(paramName, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'getSystemParameterStringByName', [paramName], additionalHeaders);
    }

    static updateDocumentMetadataAX(docDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'updateDocumentMetadata', [docDTO], additionalHeaders);
    }

    static deleteDocumentAX(serviceRequestID, publicID, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequestDocs'), 'removeDocument', [serviceRequestID, publicID], additionalHeaders);
    }

    static getServiceRequestForClaimOrServiceAX(serviceOrClaimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'ax_getServiceRequestsForClaimOrService', [serviceOrClaimNumber], additionalHeaders);
    }

    static hasAuthorityAX(authType, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'hasAuthType_ax', [authType], additionalHeaders);
    }

    static findAvailableServiceRequestForClaim(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'findAvailableServiceRequestForClaim_ax', [claimNumber], additionalHeaders);
    }

    static createNewServiceRequestAX(srDto, addressDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'createNewServiceRequestWithRetrieveNumber_AX', [srDto, addressDTO], additionalHeaders);
    }

    static axAddInvoiceSupplement(publicID, invoiceSupplementDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'axAddInvoiceSupplement', [publicID, invoiceSupplementDTO], additionalHeaders);
    }

    static cancelServiceFinishedAX(serviceRequestNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'cancelServiceFinished', [serviceRequestNumber], additionalHeaders);
    }

    static axUpdateAmountService(serviceRequestAction, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'axUpdateAmountService', [serviceRequestAction], additionalHeaders);
    }
}
